import { cn } from '../../lib/utils';

export const IPAMStatCard = ({ icon: Icon, value, label, iconClassName = 'text-primary', onClick, selected = false }) => {
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      {...(onClick ? { type: 'button', onClick, 'aria-pressed': selected } : {})}
      className={cn(
        'stats-card flex min-w-0 items-center gap-3 text-left',
        onClick && 'cursor-pointer hover:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
        selected && 'ring-2 ring-primary'
      )}
    >
      <Icon className={cn('h-6 w-6 flex-shrink-0', iconClassName)} strokeWidth={1.5} />
      <span className="min-w-0">
        <span className="stats-card-value block">{value}</span>
        <span className="stats-card-label block">{label}</span>
      </span>
    </Tag>
  );
};
